import React, {Suspense} from 'react'
import {Row, Col, FullScreenLoader, InlineLoader} from '@modifi/ui'
import {getComponentDisplayName} from '@modifi/utilities'

function withSuspense(fullScreen = true) {
  return <P extends Record<string, any>>(
    WrappedComponent: React.ComponentType<P>
  ): React.ComponentType<P> => {
    let Loader = FullScreenLoader
    if (!fullScreen) {
      Loader = () => (
        <Row justifyContent="center" mt={50}>
          <Col auto>
            <InlineLoader />
          </Col>
        </Row>
      )
    }

    const ScopedComponent: React.FC<P> = props => (
      <Suspense fallback={<Loader />}>
        <WrappedComponent {...props} />
      </Suspense>
    )
    ScopedComponent.displayName = `withSuspense(${getComponentDisplayName(WrappedComponent)})`
    return ScopedComponent
  }
}

export default withSuspense
